import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '@core/helpers/helpers';
import { CursoModel, PlanoModel, UtilizadorModel } from '@core/models';
import {
  AccountService,
  CustomMessageService,
  InscricaoService,
  StoreService,
  SubscricaoService,
} from '@core/services';
import { MessageService, PrimeIcons } from 'primeng/api';

@Component({
  selector: 'app-modal-plano-inscricao',
  templateUrl: './modal-plano-inscricao.component.html',
  styleUrls: ['./modal-plano-inscricao.component.scss'],
})
export class ModalPlanoInscricaoComponent implements OnInit {
  @Input() showModal: boolean = false;
  @Input() plano: PlanoModel;
  @Output() onClose = new EventEmitter<boolean>();

  utilizador: UtilizadorModel = null;
  tipoPagamentoSelecionado: string = 'TRANSFERENCIA';

  constructor(
    private subscricaoService: SubscricaoService,
    private storeService: StoreService,
    private accountService: AccountService,
    private messageService: CustomMessageService,
    private router: Router,
    private helper: Helpers
  ) {}

  ngOnInit(): void {
    this.helper.isAuthenticationChanged().subscribe(r => {
      if (this.helper.isAuthenticated()) this.utilizador = this.helper.getUserLogado();
    });
  }

  subscrever() {
    if (this.storeService.isAuthenticated()) {
      const subscricao = {
        planoId: this.plano.id,
        tipoPagamento: this.tipoPagamentoSelecionado,
        utilizadorId: this.utilizador.id,
      };

      this.subscricaoService.add(subscricao).subscribe(
        ({ pagamentos }) => {
          this.closeModal();
          this.messageService.showToast(
            'Subscrição realizada com sucesso',
            'success',
            'Após o pagamento, navegue até "Conta -> Subscrições" e submeta o comprovativo de pagamento. Obrigado'
          );
        },
        (err) => {
          this.messageService.showToast('Atenção', 'warn', err.mensagem);
          this.showModal = false;
        }
      );
    } else {
      this.messageService
        .customSwal()
        .fire({
          title: '',
          text: 'Inicie sua sessão para se inscrever no curso.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Iniciar Sessão',
          cancelButtonText: 'Cancelar',
        })
        .then((result) => {
          if (result.value) {
            this.router.navigate(['/autenticacao/login']);
          }
        });
    }
  }

  closeModal() {
    this.showModal = false;
    this.onClose.emit(true);
  }
}
